import React from 'react'
import PropTypes from 'prop-types'
import styles from  './Content.module.scss'

const Content = props => {
    return (
        <div className={styles.content}>
            {props.children}
        </ div>
    )
}

Content.propTypes = {
    children: PropTypes.any,
}

export default Content
